<template>
    <form class="alerta-form form-horizontal" @submit.prevent="handleSubmit">
        <!-- Observaciones de Ubicación -->
        <div class="form-group" :class="{ 'has-error': errors['mensaje'] }">
            <label for="mensaje" class="col-sm-2 control-label">Mensaje de alerta</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="mensaje" rows="8" maxlength="150" v-model="data.mensaje"></textarea>
                <small class="text-muted">{{ (data.mensaje || '').length }}/150 caracteres</small>
                <div class="help-block" v-if="errors['mensaje']" v-for="e in errors['mensaje']" :key="e">{{ e }}</div>
            </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors['activo'] }">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.activo" on-text="Si" off-text="No" :on-value="1" :off-value="0">
                </el-switch>
                <div class="help-block" v-if="errors['activo']" v-for="e in errors['activo']" :key="e">{{ e }}</div>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="/backend/red-de-atencion/call-center">Cancelar</a>
                <button type="submit" class="btn btn-primary" :disabled="isSubmitDisabled || isSubmitting">
                    {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        mensaje: {
            type: String,
            default: ''
        },
        activo: {
            type: Number,
            default: 0
        },
        routeUrl: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            data: {
                mensaje: this.mensaje,
                activo: this.activo,
            },
            isSubmitting: false,
            errors: {},
        }
    },

    computed: {
        // Deshabilitar el botón si el mensaje está vacío y está activo
        isSubmitDisabled() {
            return this.data.activo === 1 && (!this.data.mensaje || this.data.mensaje.trim() === '');
        }
    },

    watch: {
        // Actualizar data cuando cambien las props
        mensaje(newValue) {
            this.data.mensaje = newValue;
        },
        activo(newValue) {
            this.data.activo = newValue;
        }
    },

    methods: {
        async handleSubmit(event) {
            // Evitar enviar formulario con mensaje vacío y activo
            if (this.isSubmitDisabled) {
                return false;
            }

            // Reset errores al inicio
            this.errors = {};
            try {
                // Prevenir múltiples submits
                if (this.isSubmitting) {
                    return false;
                }
                
                this.isSubmitting = true;
                const response = await axios({
                    url: this.routeUrl,
                    method: 'PUT',
                    data: this.data,
                });
                
                // Redirigir si la petición fue exitosa
                if (response.data?.redirect) {
                    window.location.replace(response.data.redirect);
                } else if (response.data?.success) {
                    // Mostrar mensaje de éxito si no hay redirección
                    this.$notify && this.$notify({
                        title: 'Éxito',
                        message: 'Los cambios se guardaron correctamente',
                        type: 'success'
                    });
                }

            } catch (error) {
                // Manejar errores
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors;
                } else {
                    // Mostrar error genérico
                    this.$notify && this.$notify({
                        title: 'Error',
                        message: 'Ocurrió un error al guardar los cambios',
                        type: 'error'
                    });
                }
            } finally {
                this.isSubmitting = false;
            }
            return false;
        }
    }
}
</script>

<style lang="scss" scoped>
.ubicacion {
    background: #F7F7F7;
    border: 1px solid #F7F7F7;
    border-radius: 4px;
    display: block;
    padding-top: 14px;
    margin-bottom: 7px;
}

.subtitle {
    color: #757575;
}
</style>